import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import './DataGroup.scss';
import { DataGroupHeader } from './DataGroupHeader';

// #region Component Props

interface IProps {
    title                   : string;
    children                : any;
    actionText?             : string;
    actionClick?            : any;
    actionIcon?             : string;
    requiredPermissions?    : Permissions[];
}

// #endregion

const DataGroup = (props: IProps) => (
    <React.Fragment>
        {
            props.title && props.title.length > 0
                ? <DataGroupHeader 
                    title={props.title} 
                    actionClick={props.actionClick} 
                    actionText={props.actionText}
                    actionIcon={props.actionIcon} 
                    requiredPermissions={props.requiredPermissions}
                />
                : null
        }
        <dl className="datagroup-wrap">
            {
                props.children
            }
        </dl>        
    </React.Fragment>
);

DataGroup.defaultProps = {
    actionClick: undefined,
    actionText: undefined,
    actionIcon: undefined
};

export { DataGroup };
